import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons'

type Props = {
  onBack?: () => void
  onNext?: () => void
  nextLabel?: string
  nextLoading?: boolean
  nextDisabled?: boolean
}

const StepFooter = ({ onBack, onNext, nextLabel = 'Continue', nextLoading, nextDisabled }: Props) => {
  return (
    <div className="merchant-app-step-footer">
      {onBack && (
        <Button size="large" onClick={onBack}>
          <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} /> Back
        </Button>
      )}
      {onNext && (
        <Button
          type="primary"
          size="large"
          onClick={onNext}
          loading={nextLoading}
          disabled={nextDisabled}
        >
          {nextLabel} {!nextLoading && <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: 8 }} />}
        </Button>
      )}
    </div>
  )
}

export default StepFooter
